export default "__VITE_ASSET__DjTk6m3H__"